
class ModuleQuanlity {
    constructor(){
        this.inputQuanlityHandle();

    }

    inputQuanlityHandle = function(){
        document.querySelectorAll('.handle-quantity').forEach(container => {
            const input = container.querySelector('input[type="number"]');
            if (!input) return;
            const display = container.querySelector('.handle-item-number');
            const decrease = container.querySelector('.handle-item-decrease');
            const increase = container.querySelector('.handle-item-increase');

            const min = input.min ? parseInt(input.min) : "";
            const max = input.max ? parseInt(input.max) : Infinity;

            const updateDisplay = (value) => {
                if (isNaN(value) || value < min) value = min;
                if (value > max) value = max;

                input.value = value;
                display.textContent = value;
            };

            decrease && decrease.addEventListener('click', () => {
                let value = parseInt(input.value);
                if (isNaN(value)) value = min;
                updateDisplay(value - 1);
            });

            increase && increase.addEventListener('click', () => {
                let value = parseInt(input.value);
                if (isNaN(value)) value = min;
                updateDisplay(value + 1);
            });

            input.addEventListener('input', () => {
                updateDisplay(parseInt(input.value));
            });

            input.addEventListener('blur', () => {
                updateDisplay(parseInt(input.value));
            });
        });
    }
}

export default ModuleQuanlity; 
